import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@app/_services/api.service';
import { User, OhiUtins, AuthenticateResponse } from '@app/_models/user';
@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;

  constructor(
    private router: Router,
    private api: ApiService
  ) { 
    let user = null;
    const lsUser = JSON.parse(localStorage.getItem('user'));
    if (lsUser) {
      user = new User();
      Object.assign(user, lsUser);
    }
    this.userSubject = new BehaviorSubject<User>(user);
    this.user = this.userSubject.asObservable();    
  }

  public get userValue(): User {
    return this.userSubject?.value;
  }

  login(username: string, password: string) {
    let user = new User();
    user.userName = username;
    user.password = password;
    user.unit = OhiUtins.OhiAdmin;

    return this.api.login(user).pipe(map(authResponce => {
      if (authResponce.code !== 200) {
        return null;
      }
      Object.assign(user, authResponce.user) ;
      user.password = '';
      user.token = authResponce.token;
      localStorage.setItem('user', JSON.stringify(user));
      this.userSubject.next(user);
      return user;
    }));
  }

  updateUser(payload: any | null): void {
    const data: Partial<User> = payload as Partial<User>;
    const user = this.userSubject.value;
    user.firstName = data.firstName;
    user.lastName = data.lastName;
    user.email = data.email;
    user.password = '';
    this.userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(this.userSubject.value));
  }  

  logout() {
    localStorage.removeItem('user');
    this.userSubject?.next(null);    
    this.router.navigate(['account/login']);
  }

  register() { }

  getAll() { }

  getById(id: string) { }

}
